import { render } from "./KebabMenu.vue?vue&type=template&id=4c448636&scoped=true"
import script from "./KebabMenu.vue?vue&type=script&lang=js"
export * from "./KebabMenu.vue?vue&type=script&lang=js"

import "./KebabMenu.vue?vue&type=style&index=0&id=4c448636&scoped=true&lang=css"

import exportComponent from "../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c448636"]])

export default __exports__